import React, { Component } from 'react'
import { Button } from 'react-bootstrap'
import SelectSearchLayout from '../../../layouts/select-search'
import { permissionOperations } from '../../../../state/ducks/permissions'
import { connect } from 'react-redux'
import * as PropTypes from 'prop-types'
import { ClientShape } from '../../../../prop-types'
import { Session } from '../../../../state/utils/session'

class GroupPermissionsForm extends Component {
  constructor (props) {
    super(props)

    // set state
    this.state = {
      session: new Session()
    }

    // handlers
    this.returnOptions = this.returnOptions.bind(this)
    this.onPermissionSarchKeywordChange = this.onPermissionSarchKeywordChange.bind(this)
    this.onSelectPermission = this.onSelectPermission.bind(this)
    this.removePermission = this.removePermission.bind(this)
  }

  returnOptions () {
    const options = []
    this.props.permissions_list.forEach(element => {
      const groupAdded = this.props.added_permissions.find(p => p.toString() === element.id.toString())
      if (!groupAdded) {
        options.push({
          value: element.id + '|' + element.name,
          label: element.name
        })
      }
    })
    return options
  }

  onPermissionSarchKeywordChange (keyword) {
    this.returnOptions()
    this.props.fetchPermissions({ search: keyword })
  }

  onSelectPermission (item) {
    const addedPermissions = this.props.added_permissions
    const split_ = item.value.split('|')
    addedPermissions.push({
      id: split_[0],
      name: split_[1]
    })
    this.props.onChange(addedPermissions)
  }

  removePermission (index) {
    const addedPermissions = this.props.added_permissions
    addedPermissions.splice(index, 1)
    this.props.onChange(addedPermissions)
  }

  renderGroups () {
    return (
            <>
                <table className="table">
                    <tbody>
                    {
                        this.props.added_permissions.map((group, index) => {
                          return (
                                <tr key={index} className="border">
                                    <td style={{ width: '20px' }}>
                                        <i className="fa fa-object-group fa-2x"></i>
                                    </td>
                                    <td>
                                        <small className="font-w400">{group.name}</small>
                                        <div className="font-w400 text-muted">
                                            <small>---</small>
                                        </div>
                                    </td>
                                    <td style={{ width: '20px' }}>
                                        <Button
                                            variant="danger"
                                            className="float-right"
                                            onClick={this.removePermission.bind(this, index)}
                                        >
                                            <i className="fa fa-trash"/>
                                        </Button>
                                    </td>
                                </tr>
                          )
                        })
                    }
                    </tbody>
                </table>
                {/* <pre> */}
                {/*    <code className="json"> */}
                {/*        {JSON.stringify(this.props.added_permissions)} */}
                {/*    </code> */}
                {/* </pre> */}
            </>
    )
  }

  render () {
    return (
            <>
                <div className="form-group">
                    <div className="col-sm-6 col-sm-offset-3">
                        <div className="form-material">
                            <SelectSearchLayout
                                getOptions={this.returnOptions}
                                onSearchChange={this.onPermissionSarchKeywordChange}
                                onSelectItem={this.onSelectPermission}
                            />
                            <label htmlFor="input-groups">Search permissions</label>
                        </div>
                        {this.renderGroups()}
                    </div>
                </div>
            </>
    )
  }
}

// Set propTypes
GroupPermissionsForm.propTypes = {
  permissions_list: PropTypes.arrayOf(ClientShape).isRequired,
  fetchPermissions: PropTypes.func.isRequired
}

// Set defaultProps
GroupPermissionsForm.defaultProps = {
  permissions_list: [],
  added_permissions: [],
  onChange: () => {
  }
}

// mapStateToProps
const mapStateToProps = (state) => ({
  permissions_list: state.permissions.fetchPermissionsReducer.data.results
})

// mapStateToProps
const mapDispatchToProps = {
  fetchPermissions: permissionOperations.list
}

// Export Class
const _GroupPermissionsForm = connect(mapStateToProps,
  mapDispatchToProps)(GroupPermissionsForm)
export { _GroupPermissionsForm as GroupPermissionsForm }
